import { GPSCoordsPublishVisibility, usePublishingContext } from "../../../../../contexts/PublishingContext.js";
import { DateTime as DateTime$1 } from "../../../../../components/DateTime/index.js";
import { UserAnPCheck } from "../../../../shared/UserAnPCheck.js";
import { useMapboxToken } from "../../../../AppWrapper2/hooks/useMapboxToken.js";
import { FieldDisplayRenderWrapper } from "../components/FieldDisplayRenderWrapper.js";
import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import React, { useState } from "react";
import { Icon, Label, Loading, Tooltip } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { MdPinDrop } from "react-icons/md";
//#region src/modules/FormBuilder/components/Fields/GeoCoordinates/Display.tsx
var GeoCoordinatesMapModal = React.lazy(() => import("../../../shared/GeoCoordinatesMapModal.js").then((m) => ({ default: m.GeoCoordinatesMapModal })));
var GeoCoordinatesFieldDisplay = ({ config }) => {
	const publishingCtx = usePublishingContext();
	const { valuesByFieldId } = useFormBuilderFieldsContext();
	const [showCoordsModal, setShowCoordsModal] = useState(false);
	const mapboxToken = useMapboxToken();
	const publishingContext = usePublishingContext();
	const value = valuesByFieldId[config.id];
	if (!value) return null;
	const accuracy = value.accuracy || 0;
	return /* @__PURE__ */ jsx(GPSCoordsPublishVisibility, { children: /* @__PURE__ */ jsx(FieldDisplayRenderWrapper, {
		config,
		children: /* @__PURE__ */ jsxs("div", { children: [
			/* @__PURE__ */ jsxs("div", {
				className: "gap-x-xs inline-flex items-center justify-center",
				children: [
					/* @__PURE__ */ jsxs(Label, { children: [
						config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {}),
						config.options.displayLabel,
						" "
					] }),
					!publishingCtx?.isPublishing && /* @__PURE__ */ jsx(UserAnPCheck, {
						check: (user) => user.anp.role.portal.access.viewUserGps || user.anp.role.ops.access.viewOnDutyUsersGeoLocation,
						childrenOnCheckFail: /* @__PURE__ */ jsx(Tooltip, {
							className: "text-info",
							tooltip: "You don't have access to view GPS info. You can request GPS access from Organization admin",
							children: /* @__PURE__ */ jsx(Icon, {
								color: "main",
								Icon: MdPinDrop,
								size: "sm"
							})
						}),
						children: /* @__PURE__ */ jsx("div", {
							className: "hover:bg-surface-strong flex justify-center align-middle hover:cursor-pointer",
							onClick: () => setShowCoordsModal(true),
							children: /* @__PURE__ */ jsx(Icon, {
								color: "main",
								Icon: MdPinDrop,
								size: "sm"
							})
						})
					}),
					publishingCtx?.isPublishing && value.coords && value.coords.lat && value.coords.lng && /* @__PURE__ */ jsx("a", {
						className: "text-main text-sm underline",
						target: "_blank",
						href: `https://www.google.com/maps/?q=${value.coords.lat},${value.coords.lng}`,
						rel: "noreferrer",
						children: "View on map"
					})
				]
			}),
			/* @__PURE__ */ jsx("div", {
				className: "inline-flex w-full justify-between",
				children: /* @__PURE__ */ jsxs("div", {
					className: "flex flex-col",
					children: [value.timestamp && /* @__PURE__ */ jsxs("div", {
						className: "inline-flex",
						children: [/* @__PURE__ */ jsx(DateTime$1, { timestamp: value.timestamp }), !publishingCtx?.isPublishing && /* @__PURE__ */ jsxs("span", {
							className: "ml-2 font-bold",
							children: [
								"(",
								/* @__PURE__ */ jsx(DateTime$1, {
									relative: true,
									timestamp: value.timestamp
								}),
								")"
							]
						})]
					}), /* @__PURE__ */ jsxs("div", {
						className: classnames({
							"text-color-caution": accuracy > 250 && accuracy <= 500,
							"text-color-critical": accuracy > 500
						}),
						children: [value.accuracy, " meters accuracy"]
					})]
				})
			}),
			!publishingContext?.isPublishing && showCoordsModal && !!mapboxToken && /* @__PURE__ */ jsx(React.Suspense, {
				fallback: /* @__PURE__ */ jsx(Loading, { overlay: true }),
				children: /* @__PURE__ */ jsx(GeoCoordinatesMapModal, {
					closeHandler: () => setShowCoordsModal(false),
					device: value.device,
					geoCoordinates: value.coords,
					mapboxToken
				})
			})
		] })
	}) });
};
//#endregion
export { GeoCoordinatesFieldDisplay };

//# sourceMappingURL=Display.js.map